import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX, LocationTypes } from '@zendra/shared';
import { LocationService, ReasonService } from 'cbd-proxies';
import { OfficialPlannedPlantationHeaderService } from '../proxy/operational/controllers';
import { OfficialPlannedPlantationPlant } from '../official-planned-plantation-plant/official-planned-plantation-plant';

FieldBuilder.setNamespace('Operational');

const standLocationField = FieldBuilder.foreignKey(
  'standLocationId',
  'Entity.Stand',
  LocationService
)
  .required()
  .queryFilter({ locationTypeEntityName: LocationTypes.Stand })
  .display('name')
  .displayFromNested('standLocationName')
  .sortBy('standLocationName')
  .keyField('id')
  .build();

standLocationField.additionalGridColumns![0].label =
  'Operational::Entity.OfficialPlannedPlantation.StandLocationId';

export const OFFICIALPLANNEDPLANTATION_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'officialPlannedPlantationHeaderId',
    'Entity.OfficialPlannedPlantation.OfficialPlannedPlantationHeader',
    OfficialPlannedPlantationHeaderService
  )
    .required()
    .displayFromNested('officialPlannedPlantationHeaderId')
    .sortBy('officialPlannedPlantationHeaderId')
    .hideInChildForms()
    .build(),
  standLocationField,
  FieldBuilder.foreignKey(
    'reasonId',
    'Entity.OfficialPlannedPlantation.Reason',
    ReasonService
  )
    .required()
    .queryFilter({ reasonGroupName: 'Estado Cuadro' })
    .display('name')
    .displayFromNested('reasonName')
    .sortBy('reasonName')
    .keyField('id')
    .build(),
  FieldBuilder.text(
    'forestrySituationName',
    'Entity.OfficialPlannedPlantation.ForestrySituation',
  )
    .readOnly()
    .build(),
  FieldBuilder.number(
    'standArea',
    'Entity.OfficialPlannedPlantation.Area',
  )
    .decimal(2, 10)
    .readOnly()
    .build(),
];

export const OFFICIALPLANNEDPLANTATION_CONFIG = {
  entityName: 'OfficialPlannedPlantation',
  localizationKey: 'Operational::Entity.OfficialPlannedPlantation',
  fields: OFFICIALPLANNEDPLANTATION_FIELDS,
  permission: 'PlanningOperation.OfficialPlannedPlantations',
  showInMenu: false,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.PlanningOperational + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Silviculture + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'OfficialPlannedPlantationPlant',
      foreignKeyField: 'officialPlannedPlantationId',
      localizationKey: 'Operational::Entity.OfficialPlannedPlantationPlant',
      component: OfficialPlannedPlantationPlant,
    },
  ],
};
